import Vue from 'vue';
import VueRouter from 'vue-router';

import 'ant-design-vue/dist/antd.css';

Vue.config.productionTip = false;

import App from './App.vue';

import Login from './components/Login.vue';
import Home from './components/Home.vue';
import CommodityReview from './components/CommodityReview.vue';
import MerchantManage from './components/MerchantManage.vue';
import DeviceManage from './components/DeviceManage.vue';
import DeviceInfo from './components/DeviceInfo.vue';
import CupboardManage from './components/CupboardManage.vue';
import MerchantInfo from './components/MerchantInfo.vue';
import CupboardInfo from './components/CupboardInfo.vue';
import ReviewerInfo from './components/ReviewerInfo.vue';
import ReviewerManage from './components/ReviewerManage.vue';
import StafferInfo from './components/StafferInfo.vue';
import StafferManage from './components/StafferManage.vue';
import UserFeedback from './components/UserFeedback.vue';
import TesterManage from './components/TesterManage.vue';
import TesterInfo from './components/TesterInfo.vue';
import OrderTracking from './components/OrderTracking.vue';
import RenderQRCode from './components/RenderQRCode.vue';
import RenderBoxQRCode from './components/RenderBoxQRCode.vue';
import PrintBoxQrCode from './components/PrintBoxQrCode.vue';
import LostVideo from './components/LostVideo.vue';
import LongVideo from './components/LongVideo.vue';
import DoorCannotOpen from './components/DoorCannotOpen.vue';
import "vue-easytable/libs/theme-default/index.css";
import VueEasytable from "vue-easytable";

Vue.use(VueEasytable);
Vue.use(VueRouter);

let router = new VueRouter({
    routes: [
        { path: '/',
          component: Login,
          meta: {
              title: '金盒子智能管理系统'
          }
        },
        { path: '/home',
          component: Home,
          meta: {
              title: '金盒子智能管理系统'
          }
        },
        { path: '/commodityReview',
          component: CommodityReview,
          meta: {
              title: '商品审核'
          }
        },
        { path: '/merchantManage',
          component: MerchantManage,
          meta: {
              title: '商户管理'
          }
        },
        { path: '/merchantInfo',
          component: MerchantInfo,
          meta: {
              title: '商户详情'
          }
        },
        { path: '/cupboardInfo',
          component: CupboardInfo,
          meta: {
              title: '货柜详情'
          }
        },
        { path: '/reviewerInfo',
          component: ReviewerInfo,
          meta: {
              title: '识别系统详情'
          }
        },
        { path: '/reviewerManage',
          component: ReviewerManage,
          meta: {
              title: '识别系统管理'
          }
        },
        { path: '/stafferInfo',
          component: StafferInfo,
          meta: {
              title: '后台人员详情'
          }
        },
        { path: '/stafferManage',
          component: StafferManage,
          meta: {
              title: '后台人员管理'
          }
        },
        { path: '/userFeedback',
          component: UserFeedback,
          meta: {
              title: '意见反馈'
          }
        },
        { path: '/orderTracking',
          component: OrderTracking,
          meta: {
              title: '订单查询'
          }
        },
        { path: '/testerManage',
          component: TesterManage,
          meta: {
              title: '测试员管理'
          }
        },
        { path: '/testerInfo',
          component: TesterInfo,
          meta: {
              title: '测试员详情'
          }
        },
        { path: '/deviceManage',
          component: DeviceManage,
          meta: {
              title: '主控管理'
          }
        },
        { path: '/deviceInfo',
          component: DeviceInfo,
          meta: {
              title: '主控详情'
          }
        },
        { path: '/cupboardManage',
          component: CupboardManage,
          meta: {
              title: '货柜管理'
          }
        },
        { path: '/renderQRCode',
          component: RenderQRCode,
          meta: {
              title: '货柜二维码制作'
          }
        },
        { path: '/renderBoxQRCode',
          component: RenderBoxQRCode,
          meta: {
              title: '主控二维码制作'
          }
        },
        { path: '/printBoxQrCode',
          component: PrintBoxQrCode,
          meta: {
              title: '打印主控二维码'
          }
        },
        { path: '/lostVideo',
          component: LostVideo,
          meta: {
              title: '丢视频订单监控'
          }
        },
        { path: '/longVideo',
          component: LongVideo,
          meta: {
              title: '长视频订单监控'
          }
        },
        { path: '/doorCannotOpen',
          component: DoorCannotOpen,
          meta: {
              title: '无法开门订单监控'
          }
        },
    ]
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }

    next();
})

new Vue({
    el: '#app',
    router: router,
    render: c => c(App),
});
